<template>
    <x-container fluid app-width>
        <template v-if="loading">
            <x-layout>
                <x-flex xs12>
                    <loading-spinner class="compact" />
                </x-flex>
            </x-layout>
        </template>

        <template v-else>
            <slot name="prepend" />

            <x-layout :mt-5="!noHeader">
                <x-flex class="wizard__container">
                    <x-container fluid>
                        <wizard-header v-if="!noHeader" :title="title" :steps="steps" :currentStep="currentStep" :isComplete="isComplete" />

                        <x-layout class="wizard__step">
                            <x-flex>
                                <slot />
                            </x-flex>
                        </x-layout>
                    </x-container>
                </x-flex>
            </x-layout>
        </template>
    </x-container>
</template>

<script>
import WizardHeader from '~/components/Broker/UIComponents/WizardHeader';

export default {
    name: 'Wizard',
    props: {
        title: String,
        steps: Array,
        currentStep: Number,
        isComplete: Boolean,
        loading: Boolean,
        noHeader: Boolean,
    },
    components: {
        WizardHeader,
    },
}
</script>

<style scoped lang="scss">
.wizard__container {
    .wizard__step {
        border-radius: rem(12px);
        border-top-right-radius: 0;
        background: rgba(255, 255, 255, 0.05);

        > .flex {
            padding: 0;
        }

        .wizard-step-form {
            padding: 32px 0;

            :deep() {
                .layout {
                    animation: fade-in 1s;
                }
            }
        }

        .wizard-step-summary {
            padding: 32px;
        }
    }
}

:deep(.question-set) {
    margin: 20px -16px 64px !important;

    .question-set-title {
        font-size: rem(28px);

        .question-set-subtitle {
            color: $color-grey-4;
        }
    }

    .question-set-questions {
        padding: 0 !important;

        > .container,
        .container.question-set-questions-container {
            @include card-gradient;
            border-radius: 12px;
            padding: 20px 32px;

            &::before {
                transition: border $transition-length;
            }

            &:has(:focus) {
                background: rgba(255, 255, 255, 0.1);

                &::before {
                    border-width: 2px;
                }
            }

            > .layout,
            > div > .layout {
                margin: 0 -16px;

                &.nested {
                    margin: -16px -16px 16px 0;
                }

                > .flex {
                    padding: 12px 16px;
                }
            }
        }
    }

    &.obligors .question-set-questions > .container > .layout {
        margin: 0 -8px;

        > .flex {
            padding: 12px 8px;
        }
    }

    &.guarantors .question-set-questions > .container > .layout {
        margin: 0 -12px;

        > .flex {
            padding: 12px 12px;
        }
    }
}

:deep(.action-set) {
    margin: 20px -16px !important;

    &.action-set-wide {
        padding: 0 32px;
    }

    .action-set-actions {
        padding: 0 !important;

        > .container {
            padding: 0;
        }
    }
}
</style>
